import type { StoredAccount } from "@verbleif/shared/src/composables/AccountsStore/useAccountsStore";

/** "Location · organisation" of an account, or only the part that is known. */
export function accountContextLine(account: Pick<StoredAccount, "locationName" | "clientName">): string {
  return [account.locationName, account.clientName].filter((part): part is string => Boolean(part)).join(" · ");
}

/** The account menus list at most this many other accounts; the rest sits behind "Alle accounts". */
export const MAX_VISIBLE_OTHER_ACCOUNTS = 3;
